'use es6';

import { applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { usageTrackerMiddleware } from 'usage-tracker-redux';
import ActivitiesClient from '../api/Activities';
import AdsClient from '../api/Ads';
import AttributesClient from '../api/Attributes';
import BlogSettingsClient from '../api/BlogSettings';
import CmsUserSettingsClient from '../api/CmsUserSettings';
import ContentClient from '../api/Content';
import CrmObjectsClient from '../api/CrmObjects';
import DomainClient from '../api/Domain';
import FormsClient from '../api/Forms';
import HubDbClient from '../api/HubDb';
import IndexerClient from '../api/Indexer';
import ListsClient from '../api/Lists';
import ListRegistrationsClient from '../api/ListRegistrations';
import MABClient from '../api/MAB';
import rootEpic from '../epics';
import rootReducer from '../reducers';
import SettingsClient from '../api/Settings';
import SmartContentClient from '../api/SmartContent';
import StylesheetsClient from '../api/Stylesheets';
import TemplateClient from '../api/Template';
import VariationsClient from '../api/Variations';
import { usageTracker } from './usageTracker';
export default function configureStore(initialState) {
  return createStore(rootReducer, initialState, compose(applyMiddleware(createEpicMiddleware(rootEpic, {
    dependencies: {
      ActivitiesClient,
      AdsClient,
      AttributesClient,
      BlogSettingsClient,
      CmsUserSettingsClient,
      ContentClient,
      CrmObjectsClient,
      DomainClient,
      FormsClient,
      HubDbClient,
      IndexerClient,
      ListRegistrationsClient,
      ListsClient,
      MABClient,
      SettingsClient,
      SmartContentClient,
      StylesheetsClient,
      TemplateClient,
      VariationsClient
    }
  }), NotificationMiddleware, usageTrackerMiddleware(usageTracker)), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));
}